/* eslint-disable @angular-eslint/directive-selector */
import { Directive } from '@angular/core';

@Directive({
  selector: 'zef-form-hints',
  standalone: false
})
export class ZefFormHintsDirective { }
